import { Smartphone, FileCheck2, MapPin, Workflow, Link2, UserCog, BarChart3, Database, Sparkles } from "lucide-react";
import { Reveal, Eyebrow } from "./Motion";

const ICONS = {
  "Mobile-enabled": Smartphone,
  Paperless: FileCheck2,
  "Geo-enabled": MapPin,
  Automated: Workflow,
  Connected: Link2,
  "Employee Self-Service": UserCog,
  "Automated Workflows": Workflow,
  "Payroll Visibility": BarChart3,
  "Digital Records": Database,
};

export const DigitalByDesign = ({
  heading = "Technology that makes HR simpler, more connected and easier to manage.",
  text,
  tags = ["Mobile-enabled", "Paperless", "Geo-enabled", "Automated", "Connected"],
  footnote,
}) => (
  <section className="mx-auto max-w-[1400px] px-6 py-24 lg:px-12 lg:py-36" data-testid="digital-section">
    <div className="grid gap-8 lg:grid-cols-12">
      <Reveal className="lg:col-span-4">
        <Eyebrow>Digital by Design</Eyebrow>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-8">
        <h2 className="font-display text-3xl font-bold tracking-tight text-[#0D9488] sm:text-4xl lg:text-5xl" data-testid="digital-title">
          {heading}
        </h2>
        {text && <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#2D6A64] md:text-lg">{text}</p>}
      </Reveal>
    </div>
    <div className="mt-16 grid grid-cols-2 border-l border-t border-[#E2ECEB] sm:grid-cols-3 lg:mt-20 lg:grid-cols-5">
      {tags.map((t, i) => {
        const Icon = ICONS[t] || Sparkles;
        return (
        <Reveal key={t} delay={i * 0.07} className="border-b border-r border-[#E2ECEB] last:col-span-2 sm:last:col-span-1">
          <div className="group relative flex h-full flex-col justify-between gap-14 p-7 transition-colors duration-500 hover:bg-[#F4F9F8] lg:p-9" data-testid={`digital-feature-${i}`}>
            <span className="absolute inset-x-0 top-0 h-px origin-left scale-x-0 bg-[#D4AF37] transition-transform duration-500 group-hover:scale-x-100" />
            <Icon className="text-[#D4AF37] transition-transform duration-500 group-hover:-translate-y-1" size={28} strokeWidth={1.4} />
            <span className="font-display text-base font-semibold text-[#0D9488] sm:text-lg lg:text-xl">{t}</span>
          </div>
        </Reveal>
        );
      })}
    </div>
    {footnote && (
      <Reveal className="mt-12">
        <p className="font-display text-xl font-semibold text-[#0D9488] md:text-2xl" data-testid="digital-footnote">{footnote}</p>
      </Reveal>
    )}
  </section>
);
